import { v4 as uuid } from 'uuid';

export const FAQsData = [
	{
		id: uuid(),
		question: 'What is the cost of an online course?',
		answer:
			'Create beautiful website with this Geeks UI template. Get started building a site today.'
	},
	{
		id: uuid(),
		question: 'What do I need to take a course?',
		answer:
			'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quae aspernatur autem consequatur placeat.'
	},
	{
		id: uuid(),
		question: 'What do I receive for taking this course?',
		answer:
			'Sit amet lorem ipsum consectetur adipisicing elit. Officiis libero quibusdam minus ipsum saepe?'
	},
	{
		id: uuid(),
		question: 'What will I get if I subscribe to this Certificate?',
		answer:
			'Dolor lorem ipsum sit amet consectetur adipisicing elit. Perspiciatis magnam dolorem.'
	}
];

export default FAQsData;
